import { create } from "zustand";
import type { TUser } from "@core/types/TUser";
import { persist, createJSONStorage } from "zustand/middleware";

interface AuthState {
  user: TUser | null;
  setUser: (user: TUser | null) => void;
  logout: VoidFunction;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      logout: () => set({ user: null }),
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
